import _defineProperty from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useRef, useEffect, useState } from 'react';
import { useTheme } from 'theming';
import useStyles from './styles';
import { animated } from '@react-spring/web';
import { ClickAwayListener } from '../ClickAwayListener/ClickAwayListener';
import clsx from 'clsx';

var Modal = function Modal(_ref) {
  var _clsx;

  var children = _ref.children,
      setOpen = _ref.setOpen,
      parent = _ref.parent,
      _ref$customClassName = _ref.customClassName,
      customClassName = _ref$customClassName === void 0 ? '' : _ref$customClassName,
      _ref$interpolation = _ref.interpolation,
      interpolation = _ref$interpolation === void 0 ? {} : _ref$interpolation,
      _ref$inlineStyles = _ref.inlineStyles,
      inlineStyles = _ref$inlineStyles === void 0 ? {} : _ref$inlineStyles,
      _ref$onClickAway = _ref.onClickAway,
      onClickAway = _ref$onClickAway === void 0 ? null : _ref$onClickAway,
      _ref$closeOnClickAway = _ref.closeOnClickAway,
      closeOnClickAway = _ref$closeOnClickAway === void 0 ? true : _ref$closeOnClickAway;
  var container = useRef(null);
  var theme = useTheme();
  var classes = useStyles({
    theme: theme
  });

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      coords = _useState2[0],
      setCoords = _useState2[1];

  useEffect(function () {
    if (parent) {
      var rect = parent.getBoundingClientRect();
      setCoords({
        left: rect.x,
        top: rect.y + window.scrollY - 35
      });
    }
  }, [parent]);
  var containerStyle = clsx((_clsx = {}, _defineProperty(_clsx, classes.container, true), _defineProperty(_clsx, customClassName, Boolean(customClassName)), _clsx));

  var handleClickAway = function handleClickAway(e) {
    if (onClickAway) onClickAway(e);
    if (closeOnClickAway) setOpen(false);
  };

  return React.createElement(ClickAwayListener, {
    onClickAway: handleClickAway,
    nodeToIgnore: parent
  }, React.createElement(animated.div, {
    className: containerStyle,
    ref: container,
    style: Object.assign(Object.assign(Object.assign({}, inlineStyles), interpolation), coords)
  }, children));
};

export { Modal };